import script from "./DrivePastaTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DrivePastaTabPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__